import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toZonedTime } from 'date-fns-tz';
import { differenceInHours } from 'date-fns';

import logo from "../../images/logo.png";
import login from "../../images/icons/login.svg";
import cart from "../../images/icons/cart.svg";

import "../../css/header.css";

import previewSvg from "../../images/icons/eye.svg";

const Header = (props) => {
    const [resources, setResources] = useState({});

    const timeZone = 'Europe/Zurich';

    let navigate = useNavigate();
    const { language } = useParams();

    let languageNavPath = props.pagePath || "home";

    let pageTitle = props.pageTitle;

    const { isLoginVisible = true, isSoppingcartVisible = true, isUsernameVisible = true, ticketCount } = props;

    // Check if user is logged in
    const isLoggedIn = !!localStorage.getItem("username");

    const userName = localStorage.getItem("username");

    const loggedInDateTime = localStorage.getItem("loginDateTime");

    useEffect(() => {
        requestResources();
    }, [language]);


    //if the user is login for more than 23h remove the user from the session
    useEffect(() => {
        if (loggedInDateTime) {
            const zurichDateTimeNow = toZonedTime(new Date(), timeZone);
            const loginTime = toZonedTime(new Date(loggedInDateTime), timeZone);
            const hoursDiff = differenceInHours(zurichDateTimeNow, loginTime);

            if (hoursDiff > 23) {
                localStorage.removeItem("buyerToken");
                localStorage.removeItem("username");
                localStorage.removeItem("loggedInOrganizerId");
                localStorage.removeItem("loginDateTime");

                navigate(`/${language}/home`);
            }
        }
    }, [loggedInDateTime]);

    const requestResources = async () => {
        try {
            const res = await axios.get(`form/resources/${language}`);
            setResources(res.data?.translation);
        } catch (error) {
            console.error(error?.response?.data);
        }
    };

    const handleLanguageSwitch = (lang) => {
        if (lang !== language) {
            navigate(`/${lang}/${languageNavPath}`);
        }
    };

    // Logout handler
    const handleLogout = () => {
        localStorage.clear();
        navigate("/", { replace: true });
    };

    return (
        <header className="wow-header mt-5 mb-5">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-12 d-flex justify-content-center position-relative">
                        {/* Logo centered */}
                        <img
                            src={logo}
                            onClick={() => navigate(`/${language}/home`)}
                            alt="WOW Logo"
                            className="logo cursor-pointer" />

                        {/* Right-side icons */}
                        <div className="header-icons d-flex align-items-center position-absolute translate-middle-y" style={{ right: '0' }}>
                            {isLoggedIn && isUsernameVisible && (
                                <div className="password-input-wrapper">
                                    <input
                                        style={{ height: "40px", width: "300px", paddingBottom: "auto", paddingTop: "auto" }}
                                        className="form-control"
                                        type="text"
                                        value={userName}
                                    />
                                    <span
                                        style={{ height: "20px" }}
                                        className="password-toggle-eye remove-x"
                                        onClick={handleLogout}
                                    >
                                        X
                                    </span>
                                </div>
                            )}

                            {isLoginVisible &&
                                <img
                                    src={login}
                                    alt="Login"
                                    className="icon-login mx-2"
                                    onClick={() => isLoggedIn ? navigate(`/${language}/orders`) : navigate(`/${language}/account-login`)}
                                />
                            }

                            {isSoppingcartVisible &&
                                <>
                                    <img
                                        src={cart}
                                        alt="Cart"
                                        className={`icon-cart mx-2${ticketCount > 0 ? ' cursor-pointer' : ''}`}
                                        onClick={ticketCount > 0 ? () => navigate(`/${language}/summary`) : undefined}
                                    />
                                    {ticketCount > 0 && (
                                        <span className="cart-quantity">
                                            {ticketCount}
                                        </span>
                                    )}
                                </>
                            }

                        </div>
                    </div>
                </div>

                {/* language switch */}

                {/*<div className="row text-center mt-4">*/}
                {/*    <div className="col-md-12">*/}
                {/*        <span*/}
                {/*            className={`d-inline-block cursor-pointer ${language?.toLowerCase() === 'de' ? 'active' : ''}`}*/}
                {/*            onClick={() => handleLanguageSwitch('de')}*/}
                {/*        >*/}
                {/*            DE*/}
                {/*        </span>*/}
                {/*        <span*/}
                {/*            className={`d-inline-block cursor-pointer ms-3 ${language?.toLowerCase() === 'en' ? 'active' : ''}`}*/}
                {/*            onClick={() => handleLanguageSwitch('en')}*/}
                {/*        >*/}
                {/*            EN*/}
                {/*        </span>*/}
                {/*    </div>*/}
                {/*</div>*/}

                <div className="row text-center mt-5">
                    <div className="col-md-12">
                        <span className="title">{pageTitle}</span>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;